// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as UrlUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/UrlUtils.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function renderOrderMap(url) {
  var match = url.path;
  if (!match) {
    return ;
  }
  if (match.hd !== "order") {
    return ;
  }
  if (match.tl) {
    return ;
  }
  var urlParams = UrlUtils$Catalyst.getURLParams(url.search);
  var order_id = Js_dict.get(urlParams, "order_id");
  if (order_id !== undefined) {
    return {
            TAG: /* OrderMap */1,
            _0: order_id
          };
  } else {
    return ErrorUtils$Catalyst.raiseError("OrderMapRouteManager.re", "Invalid order_id", "");
  }
}

var RouteManager = {
  renderOrderMap: renderOrderMap
};

export {
  RouteManager ,
  
}
/* No side effect */
